import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import CardActionArea from "@mui/material/CardActionArea";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";

import { smileys } from "../itemTypes";

export default function SmileyDialog(props) {
  const theme = useTheme();
  const { t } = useTranslation();
  const { open, handleClose, handleOk, typeSmiley } = props;
  const [smileyId, setSmileyId] = useState("null");

  const handleEntering = () => {
    // check if typeSmiley is passed and is a valid type
    if (typeSmiley) setSmileyId(typeSmiley);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      TransitionProps={{
        onEntering: handleEntering,
      }}
      maxWidth="sm"
      fullWidth
      sx={{ maxWidth: "sm", margin: "auto" }}
    >
      <DialogTitle>
        {t("editor.questionTypes.smiley.smileyDialogTitle")}
      </DialogTitle>

      <DialogContent>
        <Box paddingBottom={1}>
          <Grid container spacing={3}>
            {Object.values(smileys).map((smiley) => (
              <Grid item xs={3} key={smiley} id={`smileyButton${smiley}`}>
                <CardActionArea
                  style={{ borderRadius: theme.shape.borderRadius }}
                  onClick={() => setSmileyId(smiley)}
                >
                  <Card
                    sx={{
                      minWidth: "100%",
                      background: "#fafafa",
                      border:
                        smileyId !== smiley
                          ? `3px solid #fafafa`
                          : `3px solid ${theme.palette.primary.main}`, // selected smiley
                    }}
                    onClick={() => handleOk(smiley)}
                  >
                    <Box paddingTop={1} />
                    <CardMedia
                      sx={{ width: 100, height: 100, margin: "auto" }}
                      image={`${window.REACT_APP_IMAGE_PATH}/smiley/${smiley}.png`}
                      title={t(`editor.questionTypes.smiley.${smiley}`)}
                    />
                    <Box textAlign={"center"} padding={1}>
                      <Typography variant="body2" color="textSecondary">
                        {t(`editor.questionTypes.smiley.${smiley}`)}
                      </Typography>
                    </Box>
                  </Card>
                </CardActionArea>
              </Grid>
            ))}
          </Grid>
        </Box>
      </DialogContent>
      <DialogActions sx={{ display: "flex", justifyContent: "space-between" }}>
        <Button
          startIcon={<DeleteOutlineOutlinedIcon />}
          disabled={smileyId === "null"}
          onClick={() => {
            handleOk("null");
            setSmileyId("null");
          }}
          color="secondary"
        >
          {t("editor.questionTypes.smiley.deleteSmiley")}
        </Button>
        <div>
          <Button onClick={handleClose} color="inherit">{t("common.actions.cancel")}</Button>
        </div>
      </DialogActions>
    </Dialog>
  );
}
